import React from 'react';
import { usePhrasing } from "../hooks/useSkuUtils";
import * as Constants from '../constants'
import { HeadingBuilder } from "./HeadingBuilder";
import { tax_multiplier, showOIUpdatedAt, formatMoney } from '../utils';

export const OutlayAmt = ({ trip,
  sku,
  sku_price,
  order,
  showOutlayWithTax,
  decimal_amt,  // should come in as a decimal amt (0.75), not double-digit pct ("75")
}) => {

  const { get_tax_type_suffix } = usePhrasing();
  const cstu = trip.circle.currency_subunit;

  return (
   <>
    {
      formatMoney({
        currency_symbol: trip.circle.currency_symbol,
        currency_subunit: cstu,
        amount:
          Math.round(
            sku_price
            * (showOutlayWithTax
                ? tax_multiplier({
                    tax_type: (sku.tax_type || 0),
                    trip,
                  })
                : 1
              )
            * parseFloat(decimal_amt) * cstu
          ) / cstu
      })
    }
    { // get suffix of N, R, F, or '' (for {taxType: 'no_show'})
      get_tax_type_suffix({
        taxType:
          showOutlayWithTax
            ? (sku.tax_type || 0)  // tax_type of 0 indicates 'No Tax'
            : 'no_show'
      })
    }
    <HeadingBuilder
      tippyInfoIcon = {Constants.GET_ICON_ASTERISK}
      tippyInfoText = { showOIUpdatedAt({updated_at: order.updated_at}) }
      // 10-29_ _20:11
    />
   </>
  );
}

export default OutlayAmt;